module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71b76fc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ImgPreview.vue
// module id = 3263
// module chunks = 0